import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import EcosystemQuiz from './EcosystemQuiz';

/**
 * A floating pill in the bottom-right corner that opens the ecosystem quiz.
 * Hidden on admin routes so it doesn't distract while managing submissions.
 */
const StickyQuizButton = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Hide on admin routes and while quiz is already open (button is redundant)
  const isAdmin = location.pathname.startsWith('/admin');
  if (isAdmin || location.pathname === '/') return null;

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="sticky-quiz-btn"
          data-testid="sticky-quiz-btn"
          aria-label="Not sure where to start? Take the quiz"
        >
          <HelpCircle size={18} />
          <span className="sticky-quiz-label">Not sure? Take the quiz</span>
        </button>
      )}
      {open && <EcosystemQuiz onClose={() => setOpen(false)} />}
    </>
  );
};

export default StickyQuizButton;
